const FormPhoneInputConfig = {
  // 类型
  componentType: 'FORM_PHONE_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'form-phone',
    text: '手机号码',
    optionTitle: true,
    description: '用于输入手机号码并校验格式'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 6, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormPhoneInput',
      edit: 'FormPhoneInput',
      read: 'FormPhoneInput'
    },
    label: '手机号码',
    placeholder: '请输入',
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      }
    },
    inTable: true
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'PLACEHOLDER',
    'PHONE_DEFAULT',
    'WIDTH',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ],
  excludeEditorConfigInTable: ['WIDTH']
}

export default FormPhoneInputConfig
